import { useEffect, useState } from "react";

let deferred = null;
const subs = new Set();
const emit = () => subs.forEach((f) => f(deferred));
window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; emit(); });
window.addEventListener("appinstalled", () => { deferred = null; emit(); });

export const isIOS = () => /iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isAndroid = () => /Android/i.test(navigator.userAgent);
export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const useInstallPrompt = () => {
  const [prompt, setPrompt] = useState(deferred);
  useEffect(() => { subs.add(setPrompt); return () => subs.delete(setPrompt); }, []);
  const install = async () => {
    if (!deferred) return false;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    deferred = null;
    emit();
    return outcome === "accepted";
  };
  return { prompt, install };
};
